<template>
  <div class="wrapper">
    <div class="nav" :class="{ fixed: isnav }">
      <div class="left" @click="gotopath('/kr')">
        <img src="/static/img/sk/logo-blue.png" alt="" />
      </div>
      <div class="right">
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/kr' }"
          @click="gotopath('/kr')"
          >R Series
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/kr/h1' }"
          @click="gotopath('/kr/h1')"
          >H Series
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/kr/story' }"
          @click="gotopath('/kr/story')"
          >Blueshark Story
        </span>
        <!-- <span class="navbtn" :class="{navactive: cupath=='/en/news'}" @click="gotopath('/en/news')">News</span> -->
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/kr/video' }"
          @click="gotopath('/kr/video')"
          >Blueshark Videos
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/kr/contactus' }"
          @click="gotopath('/kr/contactus')"
          >Contact Us
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/kr/support' }"
          @click="gotopath('/kr/support')"
          >Support
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/kr/app' }"
          @click="gotopath('/kr/app')"
          >App
        </span>
        <span
          class="lan"
          @mouseover="islanlist = true"
          @mouseleave="islanlist = false"
        >
          <span class="sl">Select Language</span>
          <img
            class="picker"
            :class="{ reserve: islanlist }"
            src="/static/img/sk/tobottom.png"
            alt=""
          />
          <div class="lanlist" v-show="islanlist">
            <div class="language firstlan" @click="gotopath('/cn')">
              简体中文
            </div>
            <div class="language" @click="gotopath('/tc')">繁體中文</div>
            <div class="language" @click="gotopath('/en')">English</div>
            <div class="language" @click="gotopath('/kr')">한국어</div>
          </div>
        </span>
      </div>
    </div>
    <router-view @shownav="shownav" @hidenav="hidenav"></router-view>
    <!-- <div class="footer" v-show="isfooter">
      <div class="fleft">
      </div>
      <div class="fright">
        <div class="record"> © 2019 blueshark.com All rights reserved. </div>
        <div class="fbbox" @click="toWb('https://www.facebook.com/BluesharkGlobal/')">
          <div class="fblogo">
            <img src="/static/img/facebook-w.png" alt="Blueshark facebook" style="width:100%">
          </div>
          <div class="fblogo">
            <img src="/static/img/youtobe.png" alt="Blueshark facebook" style="width:100%">
          </div>
          <div class="fbtitle">@BluesharkGlobal</div>
        </div>
      </div>
    </div> -->
    <div class="footer">
      <div class="fleft">
        <!-- <div class="homelogo"></div>
        <div class="homeline">|</div>
        <div class="hometitle">Ride the tide.</div> -->
      </div>
      <div class="fright">
        <div class="record">© 2019 blueshark.com All rights reserved.</div>
        <div
          class="fylogo"
          @click="toWb('https://www.facebook.com/BluesharkGlobal/')"
        >
          <img
            src="/static/img/sk/facebook-w.png"
            alt="Blueshark facebook"
            style="width:100%"
          />
        </div>
        <div
          class="fylogo"
          @click="
            toWb(
              'https://www.youtube.com/channel/UCuPhCdnebBCiEMKXkIaPtew/featured'
            )
          "
        >
          <img
            src="/static/img/sk/youtube.png"
            alt="Blueshark youtube"
            style="width:100%"
          />
        </div>
      </div>
    </div>
    <div class="totop" v-show="istotop" @click="toTop"></div>
  </div>
</template>

<script>
const smoothscroll = () => {
  let top =
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    window.pageYOffset
  if (top > 0) {
    requestAnimationFrame(smoothscroll)
    window.scrollTo(0, top - top / 5)
  }
}

export default {
  data() {
    return {
      isnav: false,
      istotop: false,
      isfooter: true,
      islanlist: false,
      cupath: '/kr'
    }
  },
  mounted() {
    document.title = 'Blueshark Smart Electric Motorcycle'
    this.cupath = this.$route.path
    // console.log(this.cupath,"path")
  },
  watch: {
    '$route.path'(newval, oldval) {
      this.cupath = newval
    }
  },
  methods: {
    // product
    shownav() {
      this.isnav = true
      this.istotop = true
    },
    hidenav() {
      this.isnav = false
      this.istotop = false
    },
    gotopath(path) {
      this.cupath = path
      this.$router.push(path)
    },
    toTop() {
      smoothscroll()
    },
    toWb(e) {
      window.open(e)
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;
  height: 100%;
  .nav {
    position: absolute;
    z-index: 100;
    left: 0;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    padding: 15px 50px;
    height: 60px;
    line-height: 30px;
    box-sizing: border-box;
    .left {
      cursor: pointer;
      img {
        width: 120px;
        vertical-align: middle;
      }
    }
    .right {
      text-align: right;
      padding-right: 40px;
      position: relative;
      .navbtn {
        color: #fff;
        padding: 0 20px;
        cursor: pointer;
        transition: color 0.3s;
      }
      .navbtn:hover {
        color: #0092f3;
      }
      .navactive {
        color: #0092f3;
      }
      .lan {
        color: #fff;
        display: inline-block;
        width: 150px;
        text-align: center;
        cursor: pointer;
        margin-left: 15px;
        border-left: 1px solid #666;
        .picker {
          width: 12px;
          position: relative;
          top: -2px;
          margin-left: 10px;
          transition: transform 0.3s;
        }
        .reserve {
          transform: rotate(180deg);
        }
        .sl {
          font-size: 12px;
        }
      }
      .lanlist {
        color: #fff;
        position: absolute;
        z-index: 5;
        width: 150px;
        right: 40px;
        padding: 20px 0;
        top: 25px;
        text-align: left;
        background: rgba(0, 0, 0, 0.7);
        .language {
          cursor: pointer;
          transition: color 0.3s;
          width: 100px;
          margin: 0 auto;
          line-height: 16px;
          padding-top: 15px;
          font-size: 14px;
        }
        .firstlan {
          border-top: 1px solid #666;
        }
        .language:hover {
          color: #0092f3;
        }
      }
    }
  }
  .fixed {
    position: fixed;
    background: rgba(0, 0, 0, 0.7);
    animation: navani 1s;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 120px;
    padding: 0 50px;
    background: #000;
    .fleft {
      width: 288px;
      height: 24px;
      background: url('/static/img/sk/home-logo.png') no-repeat;
      background-size: 100%;
    }
    .fright {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .record {
        color: #333;
        font-size: 14px;
      }
      .fylogo {
        width: 24px;
        height: 24px;
        margin-left: 15px;
        opacity: 0.8;
        cursor: pointer;
      }
      .fylogo:hover {
        opacity: 1;
      }
    }
  }
  // .footer{
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   height:120px;
  //   padding:0 50px;
  //   background: #000;
  //   .fleft{
  //     width:288px;
  //     height: 24px;
  //     background: url('/static/img/home-logo.png') no-repeat;
  //     background-size: 100%;
  //     }
  //   .fright{
  //     display: flex;
  //     justify-content: flex-end;
  //     align-items: center;
  //     .record{
  //       color: #333;
  //       font-size: 14px;
  //     }
  //     .fbbox{
  //       display: flex;
  //       justify-content: flex-start;
  //       align-items: center;
  //       color: #fff;
  //       cursor: pointer;
  //       .fblogo{
  //         // padding: 5px;
  //         width: 24px;
  //         height: 24px;
  //         margin:0 10px 0 15px;
  //       }
  //       .fbtitle{
  //         font-size: 16px;
  //       }
  //     }
  //     .fbbox:hover{
  //       color: #0092f3;
  //     }
  //   }
  // }
  .totop {
    position: fixed;
    z-index: 100;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
  }
  .totop::before {
    position: absolute;
    content: '';
    width: 8px;
    height: 8px;
    top: 10px;
    left: 10px;
    margin: auto;
    border-top: 3px solid #999;
    border-right: 3px solid #999;
    transform: rotate(-45deg);
  }
}
@keyframes navani {
  from {
    top: -60px;
  }
  to {
    top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sk/index.vue